import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

interface BannerProps {
  onClose: () => void;
  data: any
}

const Banner: React.FC<BannerProps> = ({ onClose, data }) => {

  const getIcon = (level: string) => {
    switch (level) {
      case 'Informational':
        return <InfoIcon className="text-black" />;
      case 'Warning':
        return <WarningIcon className="text-black " />;
      case 'Critical':
        return <ErrorIcon className="text-black" />;
      default:
        return <InfoIcon className="text-black" />;
    }
  };

  return (
    <div className="mt-18 p-2 flex justify-between items-center z-50 transition-opacity duration-300" style={{ backgroundColor: getBannerBackgroundColor(data.level) }}>
      <div className="ml-4 flex items-center">
        {getIcon(data.level)}
        <span className="text-black ml-6">{data.message}</span>
      </div>
      <CloseIcon onClick={onClose} className="cursor-pointer ml-6 mr-4 w-6 h-6" />
    </div>
  );
};

const getBannerBackgroundColor = (level: string) => {
  switch (level) {
    case 'Informational':
      return '#16A34A'; 
    case 'Warning':
      return '#FFC107';
    case 'Critical':
      return '#EF4444';
    default:
      return '#ffffff'; 
  }
};

export default Banner;
